module.exports = __webpack_public_path__ + "static/media/business-default-logo.65a21d6c.png";